import { Platform } from '@/core/Platform';
import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	reservation: {
		position: 'absolute',
	},

	ownReservation: {
		backgroundColor: 'rgba(145, 196, 194, 1)',
		borderColor: 'rgb(80, 80, 80)',
		borderWidth: 1,
		height: 27,
		top: 5,
		...Platform.select({
			web: {
				borderStyle: 'solid',
			},
		}),
	},

	blockedReservation: {
		backgroundColor: 'rgba(203, 91, 83, 1)',
		borderColor: 'rgb(80, 80, 80)',
		borderRadius: 1,
		borderStyle: 'dashed',
		borderWidth: 1,
		height: 27,
		top: 5,
	},
});
